// extracted by mini-css-extract-plugin
export default {"category_header":"CategoryHeader_category_header__Okj-A"};